"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_router_dom_1 = require("react-router-dom");
require("./Route.css");
var Route = (function (_super) {
    __extends(Route, _super);
    function Route(props) {
        return _super.call(this, props) || this;
    }
    Route.prototype.render = function () {
        if (this.props.view.length == 0) {
            return React.createElement("div", null, "INVALID ROUTE");
        }
        else {
            var view_1 = this.props.view[0];
            var viewType_1 = view_1.type;
            var renderMethod = function (props) {
                var mergedProps = __assign({}, view_1.props, props);
                return React.createElement(viewType_1, mergedProps);
            };
            return React.createElement(react_router_dom_1.Route, { exact: this.props.exact, path: this.props.path, render: renderMethod });
        }
    };
    return Route;
}(React.Component));
Route.defaultProps = {
    path: '',
    view: [],
    exact: false
};
exports.Route = Route;
if (typeof csod == 'object' && csod.engine) {
    if (!csod.engine.controls['routing'])
        csod.engine.controls['routing'] = {};
    csod.engine.controls['routing']['Route'] = Route;
}

if(!window["__LOCALES__"]) window["__LOCALES__"] = {}; window["__LOCALES__"]["Route"] = [];


//////////////////
// WEBPACK FOOTER
// ../player-routing-controls/controls/Route/index.js
// module id = 470
// module chunks = 0